<script lang="ts">
    //Image on one side and big text on other side
    export let text = '';
    export let title = '';
    export let imgsrc = '';
    export let reverse = false;
</script>

<div class="flex {reverse ? 'flex-row-reverse' : ''} flex-wrap justify-center text-center container mx-auto overflow-x-hidden md:w-full md:flex-nowrap md:w-2/3">
    <div data-animate-type="{reverse ? 'animate-slidein-right' : 'animate-slidein-left'}"> 
      <img src="{imgsrc}"
           alt="{title}"
           class="self-start" />
    </div>
    <div class="self-start p-4 md:pt-20">
      <h4 class="text-3xl">{title}</h4>
      <p class="text-xl opacity-70 pt-10 max-w-lg">
        {text}
      </p>
    </div>
  </div>